import {
  Box,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';

import { VMSize } from './VMSize';

VMResourceSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func,
  memoryKey: PropTypes.string,
  cpuKey: PropTypes.string,
  headerLabel: PropTypes.string,
  restrictSize: PropTypes.bool
};

export function VMResourceSettings({
  currentVM,
  updateCurrentVM,
  cpuKey = 'cpu',
  memoryKey = 'memory',
  headerLabel = 'Resource Settings',
  restrictSize = false
}) {
  const minCPU = currentVM?.min_cpu;
  const minMemory = currentVM?.min_memory;
  const minSize = currentVM?.templateMinSize;
  // determines if the minimum resource label should be displayed
  const isMinimumResource = memoryKey === 'min_memory' && cpuKey === 'min_cpu';

  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">{headerLabel}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isMinimumResource && (
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="overline">Minimum Resources</Typography>
            </Box>
          )}

          <VMSize
            currentVM={currentVM}
            updateCurrentVM={updateCurrentVM}
            memoryKey={memoryKey}
            cpuKey={cpuKey}
            minCPU={minCPU}
            minMemory={minMemory}
            minSize={minSize}
            restrictSize={restrictSize}
          />
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
